import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import RecordLabel from "components/RecordLabel";
import { Object_Template } from "graphql/generated/graphql";
import { History } from "history";
import { getRelativeUrl } from "utils/service";
import styles from "./CustomObjectNode.module.scss";

export interface CustomObjectContainerProps {
    data: Object_Template;
    history?: History;
    /**
     * Render the object-count badge inline in the header. Only the read-only /
     * embedded canvas does this; the interactive canvas moves the count to the
     * container footer (CustomObjectContainerNode) so the template name gets the
     * full header width — item 12 of
     * operator-task-fe-custom-object-canvas-display-improvements.
     */
    showCountBadge?: boolean;
}


export const CustomObjectContainerCard = ({
    data,
    showCountBadge = false,
}: CustomObjectContainerProps) => {
    // Total number of (non-deleted) custom objects of this template. Same field
    // the footer count uses; shown inline here only in the read-only/embedded
    // canvas (showCountBadge) where the footer is not rendered.
    const objectCount = data?.custom_object_list_object_template_id?.custom_object_count ?? 0;

    return (
        <div
            className={`${styles.parentNodeHeader} ${
                showCountBadge ? "" : styles.parentNodeHeaderWide
            }`}
        >
            <div>
                {/* The read-only/embedded canvas keeps the "Template:" prefix
                    alongside its inline count badge; the interactive canvas drops
                    it so the template name gets the full header width — item 12 of
                    operator-task-fe-custom-object-canvas-display-improvements. */}
                {showCountBadge && <>Template:&nbsp;</>}
                <RecordLabel
                    link={getRelativeUrl("object_template", data.id)}
                    name={data?.name}
                    // Standard (non-overlapping) truncation tooltip on the canvas —
                    // the in-place overlay is portalled outside the react-flow zoom
                    // transform and cannot sit centered/at-size over the scaled title
                    // (operator-task-fe-canvas-title-hover-centering-font-size).
                    hasOverlappingTooltip={false}
                    // Keep the caret pointing at containers near the canvas' right/left
                    // border (operator-task-fe-canvas-title-hover-centering-font-size).
                    edgeAwarePlacement
                />
                <Button
                    icon={IconCollection.openInNew}
                    variation="icon"
                    href={getRelativeUrl("object_template", data.id)}
                    ariaLabel="Open object template"
                />
                {showCountBadge && (
                    <span className={styles.objectCountBadge}>
                        {objectCount} {objectCount === 1 ? "object" : "objects"}
                    </span>
                )}
            </div>
        </div>
    );
};
